import { useMutation } from "@tanstack/react-query";
import { getChatApiClient } from "@shared/apis/sidekick/api-factories";
import { toast } from "@shared/services/toast";
import { SendSupportRequestResponse } from "@shared/apis/sidekick/generated";

type Props = {
  onSuccess?: (data: SendSupportRequestResponse) => void;
};

type Params = {
  threadId: string;
  description: string;
  numberOfMessages?: number;
};

export const useSendThreadSupportMessage = (props?: Props) => {
  const { onSuccess } = props || {};
  const chatApi = getChatApiClient();

  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { threadId, description, numberOfMessages } = params;
      const response = await chatApi.chatControllerSendThreadSupportRequest({
        thread: threadId,
        sendSupportRequest: {
          numberOfMessages: numberOfMessages ?? 10,
          description,
        },
      });
      onSuccess?.(response);
      return response;
    },
    onError: (error) => {
      console.error("Failed to send the support request", error);
      toast.error("Failed to send the support request");
    },
    mutationKey: ["send-thread-support-message"],
  });

  return mutation;
};
